import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=2dfc901d&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=2dfc901d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfc901d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dfc901d')) {
      api.createRecord('2dfc901d', component.options)
    } else {
      api.reload('2dfc901d', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=2dfc901d&scoped=true&", function () {
      api.rerender('2dfc901d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27JJw5TlM5gwZ/JS/comp/PopupBox.vue"
export default component.exports